import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=1168284f&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=ts"
export * from "./NewsItem.vue?vue&type=script&lang=ts"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=1168284f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168284f",
  null
  
)

export default component.exports